import DetailRegistrasiBarangJadi from './DetailRegistrasiBarangJadi';

export default DetailRegistrasiBarangJadi;
